<script>
import AnnouncementsApi from "@/services/announcements-api";
import {Languages} from "./languages";

export default {
      components: {
      },
      mounted(){
        this.getHighlights()
      },
      data() {
        return {
          highlightsList:[],
          showModal:false,
          selectedAnnouncment:{id:null,title:'',date:'',description:''},
          pagemodel: {currentPage : 1, perPage :4, totalRows: 0},
        languages:Languages,
        }
      },
      methods:{
        getHighlights(){
        //    if((this.pagemodel.totalRows-(this.pagemodel.currentPage+1))<(this.pagemodel.pageSize-1) || (this.pagemodel.currentPage-1<=0)){
        //     return ;
        //   }

        this.pagemodel.perPage = window.innerWidth < 990 ? 1 : 3;
        
        AnnouncementsApi.getHighlights(this.pagemodel.currentPage, this.pagemodel.perPage)
            .then(result => {
              if(result){
                this.highlightsList=result.list;
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;
              }
            })
        },
        increaseCurrentPage(){
            if((this.pagemodel.totalRows-(this.pagemodel.currentPage+1))<(this.pagemodel.pageSize-1)){
                return
            }
            this.pagemodel.currentPage+=1
        },
        decreaseCurrentPage(){
            if(this.pagemodel.currentPage-1<=0){
                return
            }
            this.pagemodel.currentPage-=1
        }
      }
}
</script>
<template>

    <div class="row">

            <div class="col-xs-12 col-xl-3">
                <div class="pl-4 pr-2 pt-4 pb-4 h-100" v-if="highlightsList && highlightsList.length" style="background-image:`@/assets/images/logo.png`">
        <section class="section h-100 " >
            <div class="row">
                <div class="col-lg-12">
                <div class="text-center  pt-2">
                    
                    <!-- <div class="small-title text-primary"> Actualités </div> -->
                    
                    <div class="row">
                        <div class="col-2 text-left">
                            <b-button class="d-none" variant="light" @click="decreaseCurrentPage();getHighlights()" :class="pagemodel.currentPage-1<=0 ?'d-none' : ''"><i class="fas fa-angle-double-left"/></b-button>
                        </div>
                        <div class="col-8">
                            <h4 class="text-warning text-uppercase">Nos Vidéos </h4>
                        </div>
                        <div class="col-2 text-right pr-4">
                            <b-button class="d-none" variant="light" @click="increaseCurrentPage();getHighlights()" :class="(pagemodel.totalRows-(pagemodel.currentPage+1))<(pagemodel.pageSize-1) ? 'd-none' : ''"><i class="fas fa-angle-double-right"/></b-button>
                        </div>
                    </div> 
                </div>

                </div>
            </div>
            <!-- end row -->
                

          
                    <div class="row pb-2 h-100">
                        <div class="col-sm-12 pt-2" >

                            <!-- <iframe id="video-frame" src="https://www.youtube.com/embed/8jIh3tFJavU" 
                                width="100%"
                                height="93%"
                                class="pt-2 pb-2 pr-4"
                                title="Embrayages Sachs pour véhicules de tourisme" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                allowfullscreen>
                            </iframe> -->

                            <iframe id="video-frame" src="https://www.youtube.com/embed/yq0Yv7rNhIs" 
                                width="100%"
                                height="93%"
                                class="pt-2 pb-2 pr-4"
                                title="FAG WheelBearing Video 02 Garage Satisfaction" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
        </section>

    </div>



            </div>

            <div class="col-xs-12 col-xl-9">

                <div class="pl-4 pr-4 pt-4 pb-4" v-if="highlightsList && highlightsList.length" style="background-image:`@/assets/images/logo.png`">
        <!-- <section class="section" id="news" style="background-color: rgba(254, 194, 53, 0.19)"> -->
        <section class="section" id="news">
            <div class="row">
                <div class="col-lg-12">
                <div class="text-center  pt-2">
                    
                    <!-- <div class="small-title text-primary"> Actualités </div> -->
                    
                    <div class="row">
                        <div class="col-2 text-left">
                            <b-button variant="light" @click="decreaseCurrentPage();getHighlights()" :class="pagemodel.currentPage-1<=0 ?'d-none' : ''"><i class="fas fa-angle-double-left"/></b-button>
                        </div>
                        <div class="col-8">
                            <h4 class="text-primary text-uppercase">Nos Promotions & Nouveautés </h4>
                        </div>
                        <div class="col-2 text-right pr-4">
                            <b-button variant="light" @click="increaseCurrentPage();getHighlights()" :class="(pagemodel.totalRows-(pagemodel.currentPage+1))<(pagemodel.pageSize-1) ? 'd-none' : ''"><i class="fas fa-angle-double-right"/></b-button>
                        </div>
                    </div> 
                </div>
                </div>
            </div>
            <!-- end row -->
                

          
                    <div class="row pb-2">
                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-4 pr-4 pt-2 "  v-for="(announcement) in this.highlightsList" :key="announcement.id">

                            <router-link :to="{ path: '/orders/newOrder', query: { promotionId: announcement.id }}">

                            <div class="card p-1 border border-primary shadow-none h-100">
                                <div class="p-3">
                                    <h5 :id="'tooltip-top' + announcement.id" class="text-warning truncate-title" @click="showModal=true;selectedAnnouncment=announcement" style="cursor:pointer">
                                       {{$t('current_language')==languages[0]["frensh"] ? announcement.title : $t('current_language')==languages[0]["english"] ? announcement.titleEn : announcement.title}}
                                    </h5>

                                    <div class="row">

                                        <div class="col-sm-6">
                                            <p class="text-muted mb-0">{{announcement.date}}</p>
                                        </div>

                                        <div class="col-sm-6 text-right">
                                            <a class="font-weight-bold text-white font-size-16 align-middle pr-2 pl-2" :class="announcement.tagEn ? 'bg-dark' : 'bg-white'" style="border-radius:5px;">
                                                <i class="fas fa-splotch mr-2"></i> Découvrir
                                            </a>
                                        </div>

                                    </div>

                                    

                                    
                                </div>

                                

                            <div class="position-relative">
                                <img
                                :src="'/api/image/get/' + announcement.image"
                                alt=""
                                style="max-height:28em;min-height:28em; cursor:pointer"
                                class="img-thumbnail w-100"
                                
                                @click="showModal=true;selectedAnnouncment=announcement"
                                />
                            </div>

                            <!-- <div class="p-3">
                                <ul class="list-inline">
                                <li class="list-inline-item me-3">
                                    <a href="javascript:void(0);" class="text-muted">
                                    <i
                                        class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                    ></i>
                                        {{$t('current_language')==languages[0]["frensh"] ? announcement.tag : $t('current_language')==languages[0]["english"] ? announcement.tagEn : announcement.tag}}                                    </a>
                                </li>
                                </ul>
                                <p  v-html="$t('current_language')==languages[0]['frensh'] ? announcement.description : $t('current_language')==languages[0]['english'] ? announcement.descriptionEn : announcement.description" style="min-height: 6em;max-height: 6em; overflow: hidden;" class="text-justify ">

                                </p>

                                <div>
                                <a href="javascript:void(0);" class="text-primary" @click="showModal=true;selectedAnnouncment=announcement"
                                    >{{$t('highlights.seeMore')}} <i class="mdi mdi-arrow-right"></i
                                ></a>
                                </div>
                            </div> -->
                             </div>


                            </router-link>
                </div>
            </div>
        </section>

    </div>

            </div>

    </div>



</template>
<style >
.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}
</style>
